import { Injectable } from '@angular/core';
import { AuctionBidStore } from './auction-bid.store';
import { ApiService } from '../../shared/services/core/api.service';
import { AuctionBidDetails } from './auction-bid.model';
import { Observable, of } from 'rxjs';
import { tap, mapTo } from 'rxjs/operators';
import { AuctionBidQuery } from './auction-bid.query';

@Injectable({ providedIn: 'root' })
export class AuctionBidService {
  constructor(
    private auctionBidStore: AuctionBidStore,
    private auctionBidQuery: AuctionBidQuery,
    private api: ApiService
  ) {}

  fetchBids(): Observable<null> {
    this.auctionBidStore.setLoading(true);
    const request$: Observable<null> = this.api
      .get<AuctionBidDetails>('purchases/auctionhistory')
      .pipe(
        tap(bids => this.auctionBidStore.set(bids)),
        mapTo(null)
      );

    return this.auctionBidQuery.getHasCache() ? of(null) : request$;
  }
}
